import hexRgb from 'hex-rgb';

export const toRgba = (hex: string, alpha?: number) => hexRgb(hex, { format: 'css', alpha });
